import { FilterChips } from 'shared/mui/Filter/FilterChips/FilterChips';

import { useApiClientsListFilterFields } from './hooks/useApiClientsListFilterFields';

export const ApiClientsListFilterChips: React.FC = () => {
  const fields = useApiClientsListFilterFields();

  return <FilterChips fields={fields} />;
};
